<template>
    <div class="extra-user">
        <div class="row head">
            <div class="col col-100">Extra gebruiker</div>
        </div>

        <div class="row setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.extraEmail.$error }">
                <span class="row__title">E-mailadres</span><br/>
                <input v-model="extraEmail" type="text" placeholder="Isadegroot@dubline.nl" @input="$v.extraEmail.$touch()"/>
            </div>

            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">E-mailadres</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.extraEmail.$error }">
                <input v-model="extraEmail" type="text" placeholder="Isadegroot@dubline.nl" @input="$v.extraEmail.$touch()"/>
            </div>


        </div>

        <div class="row setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.extraPassword.$error }">
                <span class="row__title">Wachtwoord</span><br/>
                <input v-model="extraPassword" type="password" placeholder="********" @input="$v.extraPassword.$touch()"/>
            </div>

            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Wachtwoord</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.extraPassword.$error }">
                <input v-model="extraPassword" type="password" placeholder="********" @input="$v.extraPassword.$touch()"/>
            </div>

        </div>
        <div class="info col">
          <p>
          Na de aanvraag wordt de extra gebruiker zo snel mogelijk
          toegevoegd aan het account, dit duurt maximaal 15 minuten.
          De nieuwe gebruiker  ontvangt een e-mail als zijn account is opgeleverd.
          </p>
          <p>
          <strong>LET OP!</strong><br>
          De kosten van een bundel lopen per maand, dus of je op de eerste
          of de laatste dag van de maand een bundel aanzet maakt niet
          uit je betaalt altijd hetzelfde bedrag.
          </p>
        </div>

        <div class="row row-button row-button--bottom">
            <div class="col col-100">
                <button @click="requestExtraNumber()" class="button">Aanvragen</button>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            extraEmail: '',
            extraPassword: '',
        }
    },

    validations: {
            extraEmail: {
                required,
                minLength: minLength(4),
                email
            },
            extraPassword: {
                required,
                minLength: minLength(4),
            },
    },

    methods: {
        requestExtraNumber () {
            if(this.$v.$invalid) {
                this.$root.ui.showDialog(
                    'Fout',
                    'De ingevulde informatie is niet correct<br/>',
                    true
                );
                return;
            }
            var _this = this;

            this.$root.ui.showDialog(
                'Extra gebruiker',
                'Er wordt nu een aanvraag ingediend voor een extra gebruiker. Hier zijn kosten aan verbonden.'
                + '<br><br> Ga je akkoord met:'
                + '<br> Extra gebruiker'
                + '<br> €1.00 per maand excl. btw'
                + '<br> maandelijks opzegbaar',
                false,
                {
                    0:{
                        name: 'Ik ga akkoord',
                        execute: function(){
                          _this.$api.post('/users/add-extra', {
                            email: _this.extraEmail,
                            password: _this.extraPassword
                          })
                            .then(response => {
                                _this.$root.loading = false;

                                _this.$root.ui.showDialog(
                                    'Voltooid',
                                    'De extra gebruiker is aangevraagd!',
                                    true
                                );
                                _this.$router.go(-1); //Back to bundels
                            })
                            .catch(e => {
                                console.log(e.response.data.message);
                                _this.$root.loading = false;
                                _this.$root.ui.showDialog(
                                    'Fout',
                                    e.response.data.message,
                                    true
                            )
                            });
                        }
                    },
                    1:{
                        name: 'Annuleren',
                        execute: function(){}
                    }
                }
            );
        },
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/bundles/ExtraUserRequest.vue